import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const ItemModulo = styled.div`
  display: flex;
`;

export const ItemButtonModulo = styled.button`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  border-radius: 0.375rem;
  border: 0;

  :hover {
    background: ${Colors.bg_color_4};
  }

  ${({ selected }) => {
    if (selected) {
      return `
        background: ${Colors.bg_color_4};
      `;
    } else {
      return `
        background: ${Colors.bgColor1};
      `;
    }
  }}

  img {
    border-radius: 0.375rem;
    width: 2.75rem;
  }
`;